import { Component, onMount, Show } from 'solid-js'
import { useSearchParams } from '@solidjs/router'
import { userStore } from '/web/store'
import { CFMark } from '/web/shared/aifans/Logo'

const AGE_VERIFICATION_KEY = 'age_verification_accepted'

const AgeVerificationModal: Component = () => {
  const state = userStore()
  const [searchParams] = useSearchParams()

  onMount(() => {
    if (searchParams.bypassAgeVerification === 'true') {
      userStore.ageVerificationModal(false)
      return
    }
    const hasVerified = localStorage.getItem(AGE_VERIFICATION_KEY)
    if (hasVerified === 'true') {
      userStore.ageVerificationModal(false)
    }
  })

  const handleAccept = () => {
    localStorage.setItem(AGE_VERIFICATION_KEY, 'true')
    userStore.ageVerificationModal(false)
  }

  return (
    <Show when={state.showAgeVerification}>
      <div
        class="fixed inset-0 z-[200] flex items-center justify-center p-5"
        style={{
          background: 'rgba(0,0,0,0.3)',
          'backdrop-filter': 'blur(6px)',
          '-webkit-backdrop-filter': 'blur(6px)',
        }}
      >
        <div
          class="w-full max-w-[340px] rounded-2xl border border-[rgba(138,43,226,0.35)] px-6 pb-6 pt-7 text-center sm:max-w-[380px]"
          style={{
            background: 'linear-gradient(180deg, #14101f 0%, #0a0814 100%)',
            'box-shadow': '0 30px 80px rgba(0,0,0,0.6), 0 0 40px rgba(138,43,226,0.1)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* CF Mark logo */}
          <div class="mb-5 flex justify-center">
            <CFMark size={64} />
          </div>

          {/* 18+ neon badge with outer glow ring */}
          <div class="mb-3.5 flex justify-center">
            <div
              class="relative flex h-[76px] w-[76px] items-center justify-center rounded-full font-bebas text-[32px] text-white"
              style={{
                background: 'linear-gradient(135deg, #8A2BE2, #FF3CAC)',
                'box-shadow':
                  '0 0 20px rgba(138,43,226,0.6), 0 0 40px rgba(255,60,172,0.3), 0 0 60px rgba(138,43,226,0.15)',
              }}
            >
              18+
            </div>
          </div>

          {/* Heading — "ONLY" in purple→pink gradient */}
          <h2 class="mb-2.5 font-bebas text-[26px] tracking-[1px]">
            ADULTS{' '}
            <span class="cf-grad-text">ONLY</span>
          </h2>

          {/* Body copy */}
          <p class="mx-auto mb-4 max-w-[280px] text-[12.5px] leading-[1.6] text-[rgba(255,255,255,0.5)]">
            This site contains adult-oriented content intended for audiences{' '}
            <strong class="text-white">18 years of age or older</strong>. By entering, you confirm
            you are of legal age in your jurisdiction and consent to viewing mature material.
          </p>

          {/* Primary CTA */}
          <button
            onClick={handleAccept}
            class="mb-2.5 w-full rounded-xl py-3 font-rajdhani text-[13px] font-extrabold uppercase tracking-[1px] text-white transition-all hover:-translate-y-0.5"
            style={{
              background: 'linear-gradient(135deg, #8A2BE2, #FF3CAC)',
              'box-shadow': '0 6px 24px rgba(138,43,226,0.4)',
            }}
          >
            I Am 18 or Older — Enter
          </button>

          {/* Ghost CTA */}
          <a
            href="https://google.com"
            class="mb-4 block w-full rounded-xl border border-[rgba(255,255,255,0.1)] py-3 font-rajdhani text-[13px] font-extrabold uppercase tracking-[1px] text-[rgba(255,255,255,0.4)] transition-all hover:border-[rgba(255,255,255,0.25)] hover:text-white"
          >
            I Am Under 18 — Exit
          </a>

          {/* Divider */}
          <div class="mb-3 h-px bg-[rgba(255,255,255,0.06)]" />

          {/* Fine print */}
          <p class="text-[10px] leading-[1.55] text-[rgba(255,255,255,0.3)]">
            By clicking <strong class="text-[rgba(255,255,255,0.5)]">Enter</strong> you agree to
            our{' '}
            <a href="/terms-of-use/" class="text-[var(--cf-cyan)] hover:text-white">
              Terms of Service
            </a>
            ,{' '}
            <a href="/privacy-policy/" class="text-[var(--cf-cyan)] hover:text-white">
              Privacy Policy
            </a>
            , and the use of cookies. We use age verification to comply with applicable laws.
          </p>
        </div>
      </div>
    </Show>
  )
}

export default AgeVerificationModal
